export default class LineupDetailsSnippetNotFoundError extends Error {}
